export const getInfoByMonth = {
  //初始化节假日数据
  module: 'tripwise-m-api',
  method: 'get',
  address: 'holidayCalendar/getInfoByMonth',
};
// 查询归属信息
export const queryEnterpriseBelong = {
  module: 'tripwise-m-api',
  method: 'POST',
  address: 'enterprise/trip/queryEnterpriseBelong',
};

// 二级页查询归属信息
export const queryEnterpriseBelongPage = {
  module: 'tripwise-m-api',
  method: 'POST',
  address: 'enterprise/trip/queryEnterpriseBelongPage',
};

// 查询企业配置信息，平台id,logo图片等
export const queryEnterpriseConfigurationInfo = {
  module: 'tripwise-m-api',
  method: 'POST',
  address: 'agent-account/get-plat-info',
};

//业务线首页常用
export const frequentlyUsedBusinessIndex = {
  module: 'tripwise-m-api',
  method: 'POST',
  address: 'frequently/used/business/index',
};

//大首页常用
export const frequentlyUsedHomepage = {
  module: 'tripwise-m-api',
  method: 'POST',
  address: 'frequently/used/index',
};

//常用城市
export const frequentlyUsedCityList = {
  module: 'tripwise-m-api',
  method: 'POST',
  address: 'frequently/used/city/list',
};

//常用酒店/航班/乘车/用车
export const frequentlyUsedBusinessList = {
  module: 'tripwise-m-api',
  method: 'POST',
  address: 'frequently/used/business/list',
};

//移除常用
export const frequentlyUsedBusinessDelete = {
  module: 'tripwise-m-api',
  method: 'POST',
  address: 'frequently/used/business/delete',
};

//添加常用
export const frequentlyUsedBusinessAdd = {
  module: 'tripwise-m-api',
  method: 'POST',
  address: 'frequently/used/business/add',
};

//编辑用车备注
export const frequentlyUsedBusinessEdit = {
  module: 'tripwise-m-api',
  method: 'POST',
  address: 'frequently/used/business/edit',
};

// 业务线首页常用
export const getFrequentlyOfBizIndex = {
  module: 'tripwise-m-api',
  method: 'POST',
  address: 'frequently/used/business/index',
};
// 业务线搜索-酒店-航班-乘车-用车 -列表
export const frequentlyUsedBusinessSearch = {
  module: 'tripwise-m-api',
  method: 'POST',
  address: 'frequently/used/business/search',
};
// 查询开票单位
export const tripQueryTitle = {
  module: 'tripwise-m-api',
  method: 'GET',
  address: 'enterprise/trip/queryTitle',
};

// 通过微信授权code获取登录用户
export const getMemberToken = {
  module: 'tripwise-m-api',
  method: 'GET',
  address: 'wechatMp/getMemberToken',
};

// 绑定会员
export const bindMember = {
  module: 'tripwise-m-api',
  method: 'POST',
  address: 'wechatMp/bindMember',
};

// 解绑会员
export const unBindMember = {
  module: 'tripwise-m-api',
  method: 'POST',
  address: 'wechatMp/unBindMember',
};

// 通过微信授权code获取绑定用户
export const getMemberByCode = {
  module: 'tripwise-m-api',
  method: 'GET',
  address: 'wechatMp/getMember-by-code',
};
// 获取token
export const getToken = {
  module: 'tripwise-m-api',
  method: 'POST',
  address: 'wechatMp/getToken',
};
// 获取企业
export const getEnterpriseInfo = {
  module: 'tripwise-m-api',
  method: 'POST',
  address: 'member/getEnterpriseInfo',
};
// 切换会员登录企业信息
export const updateCustomerEnterpriseLogin = {
  module: 'tripwise-m-api',
  method: 'POST',
  address: 'member/updateCustomerEnterpriseLogin',
};
// 获取会员返现余额
export const getCashbackSummary = {
  module: 'tripwise-m-api',
  method: 'GET',
  address: 'cashback/member/balance',
};
// 获取会员返现信息
export const getCashbackInfo = {
  module: 'tripwise-m-api',
  method: 'GET',
  address: 'cashback/member/info',
};
// 会员返现分页记录
export const getCashbackData = {
  module: 'tripwise-m-api',
  method: 'POST',
  address: 'cashback/member/record/page',
};
